import React, {Component} from 'react';

export class QuestionRankingFieldOption extends Component {
    constructor() {
        super();

        this.state = {
            dragged: false,
            over: false
        }

        this.handleDragEnd = () => {
            setTimeout(() => {
                this.setState({
                    dragged: false
                })
            }, 0);
        }

        this.handleDragStart = e => {
            const {index} = this.props;

            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('index', index);

            setTimeout(() => {
                this.setState({
                    dragged: true
                })
            }, 0);
        }

        this.handleDragOver = e => {
            if (e.preventDefault) {
                e.preventDefault();
            }

            if (!this.state.over) {
                this.setState({
                    over: true
                })
            }

            e.dataTransfer.dropEffect = 'move';
        }

        this.handleDragLeave = () => {
            this.setState({
                over: false
            })
        }

        this.handleDrop = e => {
            const {index} = this.props;
            const draggedIndex = e.dataTransfer.getData('index');
            const draggedIndexParsed = parseInt(draggedIndex);

            if (draggedIndexParsed !== index) {
                this.props.movePosition(draggedIndexParsed, index);
            }

            this.setState({
                over: false
            })
        }
    }

    render() {
        const {item, index, questionOptionsLength, disabled, questionOptions} = this.props;
        const {over, dragged} = this.state;

        return <label className={`question-options__option question-options__option--drag-and-drop${over ? ' question-options__option--over' : ''}${dragged ? ' question-options__option--dragged' : ''}`}
            onDragStart={this.handleDragStart}
            onDragEnd={this.handleDragEnd}
            onDragOver={this.handleDragOver}
            onDragLeave={this.handleDragLeave}
            onDrop={this.handleDrop}
            draggable={!disabled}
            ref={ref => {
                this.label = ref;
            }}>
            <span className="row row--align-center question-options__option-button">
                {!disabled ? <span className="question-options__option-left row row--column row--justify-center row--align-center">
                    {index > 0 && <i className="question-options__option-up fas fa-arrow-up"
                        role="button"
                        onClick={() => this.props.moveUp(index, questionOptions)}
                        tabindex="0"
                        title={`Przesuń opcję ${item.content} z pozycji ${index} na pozycję ${index - 1}`}></i>}
                    {questionOptionsLength - 1 > index && <i className="question-options__option-down fas fa-arrow-down"
                        role="button"
                        onClick={() => this.props.moveDown(index, questionOptions)}
                        tabindex="0"
                        title={`Przesuń opcję ${item.content} z pozycji ${index} na pozycję ${index + 1}`}></i>}
                </span> : <div className="question-options__option-instead-left" />}
                <span className="question-options__option-text">{item.content}</span>
            </span>
        </label>
    }
}
